// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_draftProperty_price(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "DraftPropertyExactPrice",
              "DraftPropertyPriceRange"
            ]);
}

function unwrap_fragment_draftProperty_propertyData(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "DraftPropertyDataForSaleV5",
              "DraftPropertyDataRentalV5"
            ]);
}

var fragmentConverter = {"__root":{"draftProperty_showings_date":{"b":""},"draftProperty_propertyData_DraftPropertyDataRentalV5_availableFrom":{"b":""},"draftProperty_propertyData":{"u":"fragment_draftProperty_propertyData"},"draftProperty_price":{"u":"fragment_draftProperty_price"},"draftProperty_onMlsAt":{"b":""},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_draftProperty_price: unwrap_fragment_draftProperty_price,
  fragment_draftProperty_propertyData: unwrap_fragment_draftProperty_propertyData
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function draftV5Status_decode($$enum) {
  if ($$enum === "PUBLISHED" || $$enum === "EXPIRED" || $$enum === "DRAFT" || $$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT") {
    return $$enum;
  }
  
}

function draftV5Status_fromString(str) {
  return draftV5Status_decode(str);
}

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "MULTI_UNIT" || $$enum === "LOT" || $$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
  
}

function forSalePropertyTypeEnumV5_fromString(str) {
  return forSalePropertyTypeEnumV5_decode(str);
}

function leaseLengthValue_decode($$enum) {
  if ($$enum === "SHORT" || $$enum === "LONG" || $$enum === "SHORT_OR_LONG") {
    return $$enum;
  }
  
}

function leaseLengthValue_fromString(str) {
  return leaseLengthValue_decode(str);
}

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "COMING_SOON" || $$enum === "ACTIVE" || $$enum === "OFF_MLS") {
    return $$enum;
  }
  
}

function mlsListingTypeV5_fromString(str) {
  return mlsListingTypeV5_decode(str);
}

function onOrOffV5_decode($$enum) {
  if ($$enum === "OFF" || $$enum === "ON") {
    return $$enum;
  }
  
}

function onOrOffV5_fromString(str) {
  return onOrOffV5_decode(str);
}

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
  
}

function rentalPropertyTypeEnumV5_fromString(str) {
  return rentalPropertyTypeEnumV5_decode(str);
}

function showingTypeV5_decode($$enum) {
  if ($$enum === "BUYERS_WELCOME" || $$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY") {
    return $$enum;
  }
  
}

function showingTypeV5_fromString(str) {
  return showingTypeV5_decode(str);
}

var Utils = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  onOrOffV5_decode: onOrOffV5_decode,
  onOrOffV5_fromString: onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

var node = {
  "kind": "InlineDataFragment",
  "name": "NewPropertyPageRelayFormData_inlineServerDraft"
};

var wrap_fragment_draftProperty_price = RescriptRelay_Internal.wrapUnion;

var wrap_fragment_draftProperty_propertyData = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_draftProperty_price = unwrap_fragment_draftProperty_price;
exports.wrap_fragment_draftProperty_price = wrap_fragment_draftProperty_price;
exports.unwrap_fragment_draftProperty_propertyData = unwrap_fragment_draftProperty_propertyData;
exports.wrap_fragment_draftProperty_propertyData = wrap_fragment_draftProperty_propertyData;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
